export default __webpack_public_path__ + "static/media/7.BODEGA_FERTILIZANTES.62588692.jpg";